import { render } from "./OtpInputs.vue?vue&type=template&id=bd421e16"
import script from "./OtpInputs.vue?vue&type=script&lang=js"
export * from "./OtpInputs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__